var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.character.id}},[_c('img',{attrs:{"id":_vm.character.id,"src":_vm.character.asset.src}}),_vm._v(_vm._s(_vm.character.id))])}
var staticRenderFns = []

export { render, staticRenderFns }